import FormController from './form_controller';
import RequestQueue from '../classes/RequestQueue';

class RegistrationForm extends FormController {
  static targets = [
    'email',
    'firstName',
    'lastName',
    'firm',
    'phoneNum',
    'zipCode',
    'errorMessage'
  ]

  targetNames() {
    return RegistrationForm.targets;
  }

  initialize() {
    this.apiUrl = this.data.get('api');
    this.formId = this.data.get('fmId');
  }

  async subscribe() {
    const res = await RequestQueue.addToQueue({
      method: 'post',
      url: this.apiUrl,
      data: {
        email: this.emailTarget.value,
        first_name: this.firstNameTarget.value,
        last_name: this.lastNameTarget.value,
        firm: this.firmTarget.value,
        phone_num: this.phoneNumTarget.value,
        zip_code: this.zipCodeTarget.value,
        form_id: this.formId
      }
    })

    if (res.status === 200) {
      const formInfo = res.data['form_info']
      if (formInfo['action'] == 'download') {
        this.downloadURI(formInfo['res_url'])
        this.showMessage('SUCCESS', 'Thank you', 'Your file will start to download shortly.');
        return;
      }
      window.location.href = formInfo['res_url'];
    } else {
      this.showMessage('ERROR', 'Something went wrong', 'Sorry, please try again.');
    }
  }

  showMessage(status, title, message) {
    EventManager.emit('flash-message', { status: status, title: title, message: message });
  }

  showError() {
    this.errorMessageTarget.textContent = "Looks like we're missing some information.";
    this.errorMessageTarget.classList.remove('t-hidden');
  }

  connect() {
    super.connect();
  }

  downloadURI = uri => {
    const downloadIframe = document.createElement("iframe");
    document.body.appendChild(downloadIframe);
    downloadIframe.classList.add('t-hidden');
    downloadIframe.src = uri;
  }
}

export default RegistrationForm;
